export default __webpack_public_path__ + "static/media/organizer.ee8d71bc.png";